var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdleTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-idle-time"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "idle-time",
    clipPath: "url(#clip-idle-time)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19796",
    "data-name": "Group 19796",
    transform: "translate(7910.354 -15587.264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30199",
    "data-name": "Rectangle 30199",
    width: 14,
    height: 14,
    rx: 6,
    transform: "translate(-7909.354 15588.264)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-7917.719 15588.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34156",
    "data-name": "Path 34156",
    d: "M17.2,12.468A.316.316,0,0,1,17,12.406l-1.7-1.27a.32.32,0,0,1-.129-.254V7.913a.318.318,0,1,1,.637,0v2.809l1.563,1.172a.316.316,0,0,1-.191.57Z",
    transform: "translate(-0.158 -1.8)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34157",
    "data-name": "Path 34157",
    d: "M15.342,3a.422.422,0,1,1-.422.422A.422.422,0,0,1,15.342,3Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleTime);
export default __webpack_public_path__ + "static/media/idle-time.3808e676dca82d6420eef278f3d87450.svg";
export { ForwardRef as ReactComponent };